Vue.component('form-title', require('./FormTitle').default);
Vue.component('search', require('./Search').default);
Vue.component('server-time', require('./ServerTime').default);
